import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import { InsuranceInsuredPerson } from '../model/types'
import { InsuranceParticipantsDialog } from '../ui/participants-dialog'
import { InsuranceProgramDetailsDialog } from '../ui/program-details-dialog'

export const useInsuranceDetailsDialogs = () => {
  const { openDialog, closeDialog } = useDialogBottomSheet()

  const showProgramDetails = (title: string, description: string) => {
    openDialog({
      child: (
        <InsuranceProgramDetailsDialog
          title={title}
          description={description}
          onClose={closeDialog}
        />
      ),
      backgroundColor: 'var(--white)',
      maxHeight: '100dvh',
    })
  }

  const showParticipants = (participants: InsuranceInsuredPerson[]) => {
    openDialog({
      child: (
        <InsuranceParticipantsDialog
          participants={participants}
          onClose={closeDialog}
        />
      ),
      backgroundColor: 'var(--white)',
      maxHeight: '100dvh',
    })
  }

  return { showProgramDetails, showParticipants }
}
